import { Component, OnDestroy, OnInit, ViewChild, TemplateRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { formatDate } from '@angular/common';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NgbModalConfig, NgbModal, ModalDismissReasons, NgbCalendar, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { listProjectStage } from 'src/app/web/interfaces/project/stages/create/listProjectStage';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

class listAssignment{
  id:number
  end:string
}

@Component({
  selector: 'app-project-finish-assignmento',
  templateUrl: './project-finish-assignment.component.html',
  styleUrls: ['./project-finish-assignment.component.scss']
})
export class ProjectFinishAsignmentComponent implements OnInit, OnDestroy {
  @Input() idleader = 0;

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  closeResult = ''
  model2: string

  listProjectStage: listProjectStage[] = [];
  endAssignment: listAssignment;
  endAssignmentForm: FormGroup;
  leaderid
  type: string;
  edit: boolean;
  date: string;
  idAssign: number;
  create: boolean;
  itemName: string;
  projectId: number;
  idSubcription: Subscription;
  selectedDependence
  probabilityName = 0;
  listAssigned: []


  constructor(
    private spinner: NgxSpinnerService,
    private config: NgbModalConfig,
    private modalService: NgbModal,
    private apiService: ApiServiceProject,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private ngbCalendar: NgbCalendar,
    private dateAdapter: NgbDateAdapter<string>,
    private errorService:ErrorService

  ) {
    this.idSubcription = this.activatedRoute.params.subscribe(params => {
      return this.idAssign = params['id'];
    })


  }


  ngOnDestroy(): void {
    this.idSubcription.unsubscribe();
  }


 

  ngOnInit(): void {
    this.endAssignmentForm = this.fb.group(
      {
        end: [''],

      }
    );
  }
  formSubmitt(): void {
    this.spinner.show();
    if (this.endAssignmentForm.value.end === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe rellenar todos los campos' ,text: '',icon: 'error',heightAuto: false});
      
      return;
    }
    this.date = moment(this.endAssignmentForm.value.end).format("DD-MM-YYYY");
    this.spinner.show();
    this.apiService.putService('project-end-assigned-project?id='+this.idAssign +'&assignedEndDate=' +this.date).subscribe({
      next: (data) => {
        
        if(data.message){
          Swal.fire({title:data.message ,text: '',icon: 'success',heightAuto: false})
          .then(() =>{location.reload()});
          this.spinner.hide();
        }else{
          this.spinner.hide();
          Swal.fire({title:data.error ,text: '',icon: 'error',heightAuto: false})

        }

       
      },
      error: (error) => {
        this.errorService.error(error);
      }
    });

    
  }

  

  public open(
    end: any, id: any
  ) {
   
    this.idAssign = id;

              this.endAssignmentForm.patchValue({
                end: moment( end, 'DD-MM-YYYY').format("YYYY-MM-DD")
              });


            this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
              this.closeResult = `Closed with: ${result}`;

            }, (reason) => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              this.clearForm()
            })
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  
  validField(field, form) {
    return form.controls[field].errors
      && form.controls[field].touched;
  }

  clearForm() {
    this.endAssignmentForm.reset()

    this.endAssignmentForm = this.fb.group(
      {
        end: [''],

      }
    );
  }
  
 



}

